import React from "react";
import { Form } from "@redriver/cinnamon";
import { getTemplateDocumentTypes } from "./actions";

const TemplateDocumentTypeDropdown = ({ ...props }) => (
  <Form.Dropdown {...props} lookupAction={getTemplateDocumentTypes} />
);

export default TemplateDocumentTypeDropdown;
